import $ from 'jquery'; 
$(".js-scroll-trigger").click(function () {
    $(".navbar-collapse").collapse("hide");
});

$("#mainNav").addClass("navbar-shrink");
window.scroll({
    top: 120,
    behavior: "smooth"
  })